import React from 'react';
import { useIntl } from 'react-intl';
import { SerializedPresaveWidget } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../../../../common/types';
import { WidgetListItemProps } from '../../props';

const PresaveWidgetListItemComponent: React.FC<WidgetListItemProps<SerializedPresaveWidget>> = ({ widget }) => {
  const intl = useIntl();
  const { trackTitle, releaseDate } = widget.data;

  return (
    <div className="widget-list-item-text-container">
      <span className="text-1-line">
        {intl.formatMessage(
          { id: 'app.sml.presave.block.list_item', defaultMessage: '{title} — out on {date}' },
          {
            title: trackTitle,
            // The date is a day, stored at midnight UTC. Formatted in UTC so it
            // does not slide to the day before west of Greenwich.
            date: intl.formatDate(releaseDate, { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }),
          }
        )}
      </span>
    </div>
  );
};

export const PresaveWidgetListItem = TypedMemo(PresaveWidgetListItemComponent);
